function Print(settings) {
    var privates = {};
    var publics = {};
    var events = {};
    var defaultSettings = {
        el: 'print',
        height: 569,
        width: 400,
        fontFamily: 'Lobster',
        fontColor: '#000000',
        fontSize: 78,
        maxScale: 1,
        items: [],
    };
    publics.loaded = false;
    publics.canvas = false;
    publics.numberOfTextFields = 0;

    privates.init = function () {
        privates.setup();
    };

    publics.update = function () {
        publics.updateItems();
        publics.calculateNumberOfTextFields();
        publics.canvas.renderAll();
    };

    privates.setup = function () {
        publics.loadSettings(settings);
        privates.setUpFabric();
        privates.renderItems();
        privates.registerEvents();
        publics.update();
    };

    publics.reset = function () {
        publics.loaded = false;
        publics.canvas.clear();
        privates.resetItems();
        publics.setDimensions(publics.settings.width, publics.settings.height);
        privates.renderItems();
        publics.update();
    };

    publics.calculateNumberOfTextFields = function () {
        var numberOfTextFields = 0;

        for (var key in publics.settings.items) {
            if (!publics.settings.items.hasOwnProperty(key)) {
                continue;
            }

            var item = publics.settings.items[key];

            numberOfTextFields += item.type === 'text' ? 1 : 0;
        }

        publics.numberOfTextFields = numberOfTextFields;

        return publics.numberOfTextFields;
    };

    publics.getSettings = function () {
        var output = JSON.parse(JSON.stringify(publics.settings));

        //remove fabric
        for (var key in output.items) {
            if (!output.items.hasOwnProperty(key)) {
                continue;
            }

            var item = output.items[key];

            delete item.fabric;
        }

        return JSON.parse(JSON.stringify(output));
    };

    publics.getJpeg = function (width, quality) {
        var multiplier = width / publics.settings.width;
        var output = false;

        try {
            publics.canvas.backgroundColor = '#fff';
            output = publics.canvas.toDataURL({
                format: 'jpeg',
                multiplier: multiplier,
                quality: quality || 0.8,
            });
        } catch (e) {}

        return output;
    };

    publics.getThumb = function () {
        return publics.getJpeg(380, 0.6);
    };

    publics.loadSettings = function (s) {
        publics.settings = jQuery ? jQuery.extend(defaultSettings, s) : Object.assign(defaultSettings, s);
        if (publics.settings.overlay) {
            publics.settings.items.push({
                id: 'overlay',
                type: 'image',
                value: publics.settings.overlay.image,
                width: 100,
                top: 0,
                left: 0,
                angle: 0,
                scale: 1,
                evented: false,
            });
        }
    };

    privates.registerEvents = () => {
        publics.canvas.on('mouse:up', (options) => {
            setTimeout(() => {
                privates.resetZIndexOrder();
                publics.canvas.discardActiveObject();
            }, 50);
        });
    };

    privates.resetZIndexOrder = () => {
        for (var key in publics.settings.items) {
            if (!publics.settings.items.hasOwnProperty(key)) {
                continue;
            }

            var item = publics.settings.items[key];

            if (typeof item.fabric !== 'undefined') {
                item.fabric.moveTo(item.zIndex || key);
            }
        }
    };

    privates.setUpFabric = function () {
        publics.canvas = new fabric.Canvas(publics.settings.el, {
            backgroundColor: '#fff',
        });
        publics.setDimensions(publics.settings.width, publics.settings.height);
    };

    publics.setDimensions = function (width, height) {
        if (!publics.canvas || !width || !height) {
            return false;
        }

        publics.settings.width = width;
        publics.settings.height = height;

        if (publics.settings.overlay) {
            publics.settings.overlay.composed = {
                top: (height * publics.settings.overlay.itemsPosition.top) / 100,
                left: (width * publics.settings.overlay.itemsPosition.left) / 100,
                width: width * publics.settings.overlay.itemsPosition.scale,
                height: height * publics.settings.overlay.itemsPosition.scale,
            };
        }

        publics.canvas.setHeight(height);
        publics.canvas.setWidth(width);
        publics.canvas.requestRenderAll();
    };

    privates.resetItems = function () {
        for (var key in publics.settings.items) {
            if (!publics.settings.items.hasOwnProperty(key)) {
                continue;
            }

            var item = publics.settings.items[key];

            delete item.fabric;
        }
    };

    privates.renderItems = function () {
        for (var key in publics.settings.items) {
            if (!publics.settings.items.hasOwnProperty(key)) {
                continue;
            }

            var item = publics.settings.items[key];

            if (typeof item.fabric === 'undefined') {
                switch (item.type) {
                    case 'text':
                        item.fabric = publics.createTextEl(item);
                        item.fabric.evented = false;
                        break;
                    case 'image':
                        (function (item) {
                            publics.createImageEl(item, function (image) {
                                item.fabric = image;
                                item.fabric.evented = false;
                                publics.update();

                                if (!publics.loaded && privates.isEverythingLoaded()) {
                                    publics.loaded = true;
                                    privates.trigger('load');
                                }
                            });
                        })(item);

                        break;
                    default:
                        // statements_def
                        break;
                }
            }
        }
    };

    privates.isEverythingLoaded = function () {
        var output = true;

        for (var key in publics.settings.items) {
            if (!publics.settings.items.hasOwnProperty(key)) {
                continue;
            }

            output = output && typeof publics.settings.items[key].fabric === 'object';
        }

        return output;
    };

    publics.updateItems = function () {
        for (var key in publics.settings.items) {
            if (!publics.settings.items.hasOwnProperty(key)) {
                continue;
            }

            var item = publics.settings.items[key];

            if (typeof item.fabric !== 'undefined') {
                //fix zIndex since some resources are loaded async
                item.fabric.moveTo(item.zIndex || key);
                item.fabric.evented = item.evented || false;
                item.fabric.hasControls = false;

                if (item.evented) {
                    (function (item) {
                        item.fabric.on('mouseover', () => {
                            publics.toggleCanvasClass(true);
                        });

                        item.fabric.on('mouseout', () => {
                            publics.toggleCanvasClass(false);
                        });
                        item.fabric.on('moving', function (options) {
                            item.fabric.set('opacity', 0.7);
                            item.fabric.on('mouseup', function (event) {
                                item.fabric.off('mouseup');
                                item.fabric.set('opacity', 1);

                                item.left = (item.fabric.left / publics.canvas.width) * 100;
                                item.top = (item.fabric.top / publics.canvas.height) * 100;

                                //publics.updateItems()
                                publics.canvas.discardActiveObject();
                            });
                        });
                    })(item);
                } else {
                    item.fabric.selectable = false;
                }

                switch (item.type) {
                    case 'text':
                        publics.updateTextEl(item);
                        break;
                    case 'background':
                        break;
                    case 'image':
                        publics.updateImageEl(item);
                        break;
                    default:
                        // statements_def
                        break;
                }
            }
        }
    };

    publics.toggleCanvasClass = (add = true) => {
        const canvas = document.getElementById('print-wrapper');
        if (add) {
            canvas.classList.add('print-hovering');
        } else {
            canvas.classList.remove('print-hovering');
        }
    };

    publics.createTextEl = function (item) {
        var text = new fabric.Text(item.value, {
            fontFamily: item.fontFamily || publics.settings.fontFamily,
        });

        if (item.direction == 'vertical') {
            text.centeredRotation = true;
            text.rotate(90);
        }

        publics.canvas.add(text);

        return text;
    };

    publics.updateTextEl = function (item) {
        var text = item.fabric;
        let left = 0;
        let top = 0;

        item.value = item.value.replace(
            /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
            ''
        );
        var scale = { x: 1, y: 1 };
        var maxScale = item.maxScale || publics.settings.maxScale;

        if (item.maxLength && item.value.length > item.maxLength) {
            item.value = item.value.slice(0, item.maxLength);
        }

        if (item.newlineOnSpace) {
            text.set('text', item.value.split(' ').join('\n'));
        } else if (item.newlineOnEveryChar) {
            text.set('text', item.value.split('').join('\n'));
        } else {
            text.set('text', item.value);
        }

        if (item.stroke) {
            text.set('stroke', item.stroke);
        }

        //text.set('lineHeight', '1px')
        text.set('lineHeight', item.lineHeight || item.fabric.height || 0);
        text.set('fontFamily', item.fontFamily || publics.settings.fontFamily || 'Arial');

        var fontSize = item.fontSize || publics.settings.fontSize || 300;

        if (fontSize.indexOf && fontSize.indexOf('%') !== -1) {
            fontSize = (parseFloat(fontSize) / 100) * publics.settings.width;
        }

        text.set('fontSize', fontSize);

        text.set('fontWeight', item.fontWeight || publics.settings.fontWeight || 'normal');
        text.setColor(item.fontColor || publics.settings.fontColor || '#000000');

        if (item.centeredPositioning) {
            text.originX = 'center';
            text.originY = 'center';
            text.centeredRotation = true;

            left = publics.settings.width * (item.left / 100);
            top = publics.settings.height * (item.top / 100);
        } else if (typeof item.width !== 'undefined') {
            //bug workaround, fabric calculates the wrong width when emojis are used
            if (text.width <= 2) {
                text.set(
                    'width',
                    privates.calculateTextWidth(text.text, 'normal ' + text.fontSize + 'px ' + text.fontFamily)
                );
            }

            scale.x = Math.min((publics.settings.width * item.width) / 100 / text.width, maxScale);
            scale.y = scale.x;

            if (item.align == 'left') {
                left = publics.settings.width * (item.left / 100);
            } else if (item.align == 'right') {
                left =
                    publics.settings.width * (item.left / 100) +
                    ((publics.settings.width * item.width) / 100 - text.width);
            } else {
                if (scale.x < maxScale) {
                    left = publics.settings.width * (item.left / 100);
                } else {
                    left =
                        publics.settings.width * (item.left / 100) +
                        ((publics.settings.width * item.width) / 100 - text.width) / 2;
                }
            }

            top = publics.settings.height * (item.top / 100) - (text.height * scale.x) / 2;
        } else if (typeof item.height !== 'undefined') {
            text.set('textAlign', 'center');
            scale.y = Math.min((publics.settings.height * item.height) / 100 / text.height, maxScale);
            scale.x = scale.y;

            if (item.align == 'top') {
                top = publics.settings.height * (item.top / 100);
            } else {
                if (scale.y < maxScale) {
                    top = publics.settings.height * (item.top / 100);
                } else {
                    top =
                        publics.settings.height * (item.top / 100) +
                        ((publics.settings.height * item.height) / 100 - text.height) / 2;
                }
            }

            left = publics.settings.width * (item.left / 100) - (text.width * scale.y) / 2;
        }

        if (item.angle) {
            text.rotate(item.angle);
        }

        if (publics.settings.overlay) {
            let leftStart = left / publics.settings.width;
            let topStart = top / publics.settings.height;
            scale.x *= publics.settings.overlay.itemsPosition.scale;
            scale.y *= publics.settings.overlay.itemsPosition.scale;
            left = publics.settings.overlay.composed.left + publics.settings.overlay.composed.width * leftStart;
            top = publics.settings.overlay.composed.top + publics.settings.overlay.composed.height * topStart;
        }

        text.set('left', left);
        text.set('top', top);

        text.scaleX = scale.x;
        text.scaleY = scale.y;
    };

    publics.createImageEl = function (item, cb) {
        let image = item.value;
        if (item.editor && !location.href.includes('prints/studentskylt')) {
            image = item.editor;
        }
        if (item.id == 'overlay' && location.href.includes('prints/studentskylt')) {
            return;
        }

        fabric.Image.fromURL(
            image,
            function (img) {
                publics.canvas.add(img);
                cb(img);
            },
            {
                crossOrigin: 'anonymous',
            }
        );
    };

    publics.updateImageEl = function (item) {
        var image = item.fabric;

        image.set('centeredRotation', true);

        var scale = (publics.settings.width / image.width) * ((item.width * item.scale) / 100);

        if (item.centeredPositioning) {
            image._setOriginToCenter();
        }

        let left = publics.settings.width * (item.left / 100);
        let top = publics.settings.height * (item.top / 100);

        if (publics.settings.overlay && item.id == 'bg') {
            scale *= publics.settings.overlay.itemsPosition.scale;
            left = publics.settings.overlay.composed.left;
            top = publics.settings.overlay.composed.top;
        } else if (publics.settings.overlay && item.id != 'overlay') {
            let leftStart = left / publics.settings.width;
            let topStart = top / publics.settings.height;
            scale *= publics.settings.overlay.itemsPosition.scale;
            left = publics.settings.overlay.composed.left + publics.settings.overlay.composed.width * leftStart;
            top = publics.settings.overlay.composed.top + publics.settings.overlay.composed.height * topStart;
        }

        image.set('left', left);
        image.set('top', top);

        image.scale(scale);
        image.rotate(item.angle);
    };

    privates.calculateTextWidth = function (text, font) {
        // re-use canvas object for better performance
        var canvas = privates.canvas || (privates.canvas = document.createElement('canvas'));
        var context = canvas.getContext('2d');
        context.font = font;
        var metrics = context.measureText(text);
        return metrics.width;
    };

    privates.trigger = function (event) {
        if (typeof events[event] === 'function') {
            events[event]();
        }
    };

    publics.on = function (event, cb) {
        if (typeof cb === 'function') {
            events[event] = cb;
        }
    };

    privates.init();
    return publics;
}

if (typeof define !== 'undefined') {
    define(function () {
        return Print;
    });
}

if (typeof exports !== 'undefined') {
    var fabric = require('../../../../printbuddy/node_modules/fabric').fabric;
    exports.printBuddy = PrintBuddy;
}
